<template>
  <div class="col-12">
    <div v-if="percent < 70">
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
    </div>
    <div v-else-if="69 < percent && percent < 80">
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
    </div>
    <div v-else-if="79 < percent && percent < 90">
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
    </div>
    <div v-else>
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="blaSummaryScoreStar"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percent: Number
  }
};
</script>
